import { FC, ReactNode } from 'react'

import styled from 'styled-components'
import { useMediaQuery } from 'react-responsive'

import { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH } from 'src/Styled/variables'

import { StatsSectionInner } from '../StatsSectionInnerBlock/components'

import { StatsSectionProps } from './components/index'

export interface StatsBlockProps {
  sections: StatsSectionProps[]
  icon?: ReactNode
  $isHorizontal?: boolean
}

interface Props {
  $isHorizontal?: boolean
}

const StatsBlockContainer = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 24px;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    box-shadow: none;
    display: ${(props: Props) => (props.$isHorizontal ? 'flex' : 'grid')};
    grid-template-columns: ${(props: Props) =>
      !props.$isHorizontal && 'repeat(2, 1fr)'};
  }
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 32px;
`

export const StatsBlock: FC<StatsBlockProps> = ({
  sections,
  $isHorizontal,
  icon,
}) => {
  const isDesktop = useMediaQuery({ minWidth: MAX_TABLET_WIDTH })

  return (
    <StatsBlockContainer $isHorizontal={$isHorizontal}>
      {icon && isDesktop ? <IconWrapper>{icon}</IconWrapper> : null}
      {sections.map((section) => (
        <StatsSectionInner key={section.title} {...section} />
      ))}
    </StatsBlockContainer>
  )
}
